import _extends from "@babel/runtime/helpers/extends";
import isNil from '@tinkoff/utils/is/nil';
import isString from '@tinkoff/utils/is/string';
import cn from 'classnames';
import { getElementStyles } from './get-element-style';
const getComponentStyleSlot = componentLayer => {
  if (isString(componentLayer)) {
    return {
      className: componentLayer,
      style: {}
    };
  }
  return componentLayer;
};
export const useStyleSlots = (styleSlots, baseSlot, componentLayers, props) => {
  const result = {};
  const slotNames = Object.keys(componentLayers);
  for (const slotName of slotNames) {
    var _styleSlots$slotName;
    const componentLayer = getComponentStyleSlot(componentLayers[slotName]);
    const styleSlot = (_styleSlots$slotName = styleSlots == null ? void 0 : styleSlots[slotName]) != null ? _styleSlots$slotName : {};
    if (slotName === 'base' && !isNil(baseSlot.className)) {
      styleSlot.className = cn(styleSlot.className, baseSlot.className);
    }
    if (slotName === 'base' && !isNil(baseSlot.style)) {
      styleSlot.style = _extends({}, styleSlot.style, baseSlot.style);
    }
    result[slotName] = getElementStyles(slotName, styleSlot, componentLayer, props);
  }
  return result;
};